const CACHE_TTL = 10 * 60 * 1000; // 10 minutes

const key = (userId: string | number) => `profile_data_${userId}`;

export const getProfileCache = (userId: string | number): any | null => {
  try {
    const raw = localStorage.getItem(key(userId));
    if (!raw) return null;
    const { data, fetchedAt } = JSON.parse(raw);
    if (Date.now() - fetchedAt > CACHE_TTL) {
      localStorage.removeItem(key(userId));
      return null;
    }
    return data;
  } catch {
    return null;
  }
};

export const setProfileCache = (userId: string | number, data: any): void => {
  try {
    localStorage.setItem(key(userId), JSON.stringify({ data, fetchedAt: Date.now() }));
  } catch {}
};

export const clearProfileCache = (userId: string | number): void => {
  try {
    localStorage.removeItem(key(userId));
  } catch {}
};

export const patchProfileCache = (userId: string | number, patch: Record<string, any>): void => {
  try {
    const raw = localStorage.getItem(key(userId));
    if (!raw) return;
    const parsed = JSON.parse(raw);
    parsed.data = { ...parsed.data, ...patch };
    localStorage.setItem(key(userId), JSON.stringify(parsed));
  } catch {}
};
